import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {SIZE_PAGINATION} from "../../conf";

export const findPersonBasicData = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/basicData`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/basicData', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/basicData`);
    })
}

export const useFindPersonBasicData = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonBasicData(data),
    });
}

export const findPersonList = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/search/${data?.type}`,
        {
            identifier: data.identifier,
            page: data?.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object) ?
                interceptorResponse(response.data.object) :
                {
                    content: [],
                    pageable: {
                        offset: 0,
                        pageNumber: 0,
                        pageSize: 0,
                        paged: false,
                        unpaged: false,
                    },
                    totalPages: 0,
                    totalElements: 0,
                    last: true,
                    size: 0,
                    number: 0,
                    first: false,
                    numberOfElements: 0,
                    empty: true
                }
        }
    }).catch(error => {
        errorHandlerServices(error, true, `/search/${data?.type}`, undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /search/${data?.type}`);
    })
}

export const useFindPersonList = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonList(data),
    });
}

export const findPersonLicence = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/information/driverLicense`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/information/driverLicense', undefined, data?.msj)
        getError(error, error?.response?.data?.message ? error?.response?.data?.message : `Error service: /information/driverLicense`);
    })
}

export const useFindPersonLicence = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPersonLicence(data),
    });
}
